import { useMemo } from "react";

import { StackRolesBulkActionItem } from "../types";
import useUnassignStackRolesBulkAction from "./useUnassignStackRolesBulkAction";

const useStackRolesBulkActions = (): StackRolesBulkActionItem[] => {
  const unassignStackRolesBulkAction = useUnassignStackRolesBulkAction();

  return useMemo(() => [unassignStackRolesBulkAction], [unassignStackRolesBulkAction]);
};

export default useStackRolesBulkActions;
